/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100UnauthorizedException } from './Ptw100UnauthorizedException';
import {
    Ptw100UnauthorizedExceptionFromJSON,
    Ptw100UnauthorizedExceptionFromJSONTyped,
    Ptw100UnauthorizedExceptionToJSON,
} from './Ptw100UnauthorizedException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100UnauthorizedException
 */
export interface ErrorResponseOfPtw100UnauthorizedException {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseOfPtw100UnauthorizedException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100UnauthorizedException}
     * @memberof ErrorResponseOfPtw100UnauthorizedException
     */
    exception: Ptw100UnauthorizedException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100UnauthorizedException
     */
    $type?: ErrorResponseOfPtw100UnauthorizedExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100UnauthorizedExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100UnauthorizedExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100UnauthorizedException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100UnauthorizedExceptionTypeEnum = typeof ErrorResponseOfPtw100UnauthorizedExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100UnauthorizedExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100UnauthorizedException interface.
 */
export function instanceOfErrorResponseOfPtw100UnauthorizedException(value?: unknown): value is ErrorResponseOfPtw100UnauthorizedException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100UnauthorizedExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(json: any): ErrorResponseOfPtw100UnauthorizedException {
    return ErrorResponseOfPtw100UnauthorizedExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100UnauthorizedExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100UnauthorizedException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100UnauthorizedExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100UnauthorizedExceptionToJSON(value?: Omit<ErrorResponseOfPtw100UnauthorizedException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100UnauthorizedExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

